import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, Typography } from "@material-ui/core";
import { AppContext } from "../AppContext";
import FullScreenPage from "./FullScreenPage";
import RevokeOrderForm from "./RevokeOrderForm";
import ConfirmationDialog from "./ConfirmationDialog";
import LogoSquare from "../assets/plagaware-logo-square-50x50.png";
import { showCaptcha } from "../helpers/constants";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 500,
        width: "100%",
    },
}));

export default function RevokeContractPage() {
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();
    const [pageHidden, setPageHidden] = React.useState(false);

    useEffect(() => {
        showCaptcha();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (pageHidden) return null;

    return (
        <FullScreenPage>
            <ConfirmationDialog />
            <Box display="flex" justifyContent="center" width="100%">
                <Paper className={classes.paper} elevation={4}>
                    <img src={LogoSquare} alt="logo" style={{ marginBottom: 16 }} />
                    <Typography component="h1" variant="h5" paragraph>
                        {s.revokeOrderForm.title}
                    </Typography>
                    <Box width="100%">
                        <RevokeOrderForm standalone={true} open={true} onClose={() => {}} onHide={() => setPageHidden(true)} />
                    </Box>
                </Paper>
            </Box>
        </FullScreenPage>
    );
}
